
<body>

    <mat-card class="card">
        <img class="logo1" src="../../../assets/img/flat-lay-photography-of-vegetable-salad-on-plate-1640777.jpg" >
    <form  class="main">
        
            <span class="title">Login as a Admin User</span>
            <span></span>

            <div class="row1">
                <mat-form-field  class=""><mat-label>Email</mat-label><mat-icon class="icon">person</mat-icon>
                    <input type="email" matInput placeholder="Email"  [(ngModel)]="email" name="email"></mat-form-field> 
            </div>            
            <div class="row1">
                <mat-form-field>
                    <mat-label>Password</mat-label><mat-icon class="icon" (click)="changeVisibility(visibility)">{{visibility}}</mat-icon>
                <input  type={{type}} matInput placeholder="Password" [(ngModel)]="password" name="password">
            </mat-form-field> 
            </div>
            <div class="row1">
                    <button  mat-button class="btn1" (click)="verify()">Login</button>
           
            </div>
            
        <div class="forgetpassword">
            <button class="btn2" (click)="forget()">Forget Password?</button>
        </div>
        <div class="forgetpassword">
            <button class="btn3" (click)="change()">Change Password</button>
        </div>
<div>
    <p id="terms">Terms of use Privacy Policy</p>
</div>
        </form>    
    </mat-card>
</body>